import { AxiosPromise } from 'axios';
import { ReducerDataState } from 'shared/interface/globalInterface';

export enum ACTIONS {
  DEFAULT = 'DEFAULT',
  SUCCESS = 'FETCH',
  START = 'START',
  ERROR = 'ERROR',
  RESET = 'RESET',
}

export type State<T = any> = ReducerDataState<T>;

export type Fetcher<T = any> = {
  fetch: () => Promise<T>;
};

export type RequestInvocation<T = any> = () => AxiosPromise<T>;
